import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getJrSummary } from '../services/jrOverview.js';

const RYTMUS = [
  ['Po a st', 'Huddle 10 minut v Rozjezdu, ve svátek odpadá. Hned po něm odškrtneš účast. Ráno mrkneš, kdo včera nezapsal.'],
  ['Po–st', 'Review 30 minut pro skupinu nejvýš 10 lidí. Po něm odškrtneš účast a uzavřeš týden – když ho do čtvrtka neuzavřeš, Drill ho uzavře sám před odesláním reportu.'],
  ['St', 'Provize z Maxisu. Ve čtvrtek večer odchází report pro JCH – připravovat ho nemusíš.'],
  ['14denně', '1:1 s makléřem v červené na úrovni 2–3 (30 min). V režimu podpory 15–20 minut.'],
  ['Měsíčně', 'Po 20.: zařazení do úrovní, 1:1 na úrovni 2–3, půlhodina s JCH nad ukazateli.'],
  ['Příprava', 'Nováčka v přípravě vede JCH. Ty připravíš účet a uzavíráš týden.'],
  ['Hned', 'Mimo report se JCH hned hlásí: řeč o odchodu, finanční tíseň, nesložená zkouška, stížnost klienta.'],
];

const MENI = [
  'Zařazení do úrovní – Drill navrhuje, zapisuje JR, JCH může zápis změnit.',
  'Týdenní plán makléře – předvyplní Drill, změnit může JR nebo JCH.',
  'Nahrání vyplacených provizí z Maxisu, nebo ruční zadání.',
  'Účty makléřů: příprava, pozvánka, skupiny, ukončení.',
  'Parametry a číselníky – mění JR a JCH společně.',
  'Dovolené makléřů a denní připomínka.',
  'Opravy zápisů po uzavření týdne.',
];

const NENI = [
  'Report pro JCH – chodí automaticky ve čtvrtek.',
  'Vedení nováčka v přípravě – to dělá JCH.',
  'Rozhodování o penězích, náboru a ukončení spolupráce – to je na JCH.',
  'Zadávání dat za makléře – každý si zapisuje sám.',
  'Ověřování zapsaných oslovení a schůzek – berou se tak, jak je makléř zapíše.',
];

const dt = (d) => (d ? new Date(d).toLocaleDateString('cs-CZ') : '—');

export default function JrSprava() {
  const [data, setData] = useState(null);

  useEffect(() => {
    getJrSummary().then(setData).catch(() => setData(null));
  }, []);

  const missing = data ? data.missing_yesterday.length : '—';
  const total = data ? data.maklers.length : '—';

  const tasks = [
    ['1. Nahrát provize z Maxisu', 'středa', '/dashboard/import', `Poslední import ${dt(data?.last_import)}`],
    ['2. Uzavřít týden makléřů', 'do čtvrtka', '/dashboard/database', 'Detail makléře → Týden uzavřen'],
    ['3. Zařazení do úrovní', 'po 20. v měsíci', '/dashboard/level-assignment', 'Bez provizí nesedí tempo a bez tempa nejde rozhodnout o úrovních.'],
  ];

  return (
    <section className="dashboard">
      <div className="dashboard__header">
        <div>
          <h1 className="dashboard__title">Správa: co kdy udělat</h1>
          <p className="dashboard__lead">
            Drill spravuje manažerský přístup – JR a JCH. Tady je tvůj rytmus, úkoly a stav dat na
            jednom místě.
          </p>
        </div>
      </div>

      <div className="card">
        <h2 className="card__title">Úkoly · tento týden a měsíc</h2>
        <ul className="jr-list">
          {tasks.map(([t, kdy, to, note]) => (
            <li key={t}>
              <strong>{t}</strong> · {kdy} – <Link to={to}>otevřít</Link>
              <br />
              <small>{note}</small>
            </li>
          ))}
        </ul>
      </div>

      <div className="card">
        <h2 className="card__title">Stav dat</h2>
        <ul className="jr-list">
          <li>Provize nahrané: poslední import {dt(data?.last_import)}</li>
          <li>Makléři bez včerejšího zápisu: {missing} z {total}</li>
          <li>Upozornění k vyřízení: {data ? data.alerts.length : '—'}</li>
        </ul>
      </div>

      <div className="card">
        <h2 className="card__title">Tvůj rytmus</h2>
        <ul className="jr-list">
          {RYTMUS.map(([k, v]) => (
            <li key={k}><strong>{k}</strong> – {v}</li>
          ))}
        </ul>
      </div>

      <div className="card">
        <h2 className="card__title">Mění správce</h2>
        <ul className="jr-list">{MENI.map((t) => <li key={t}>{t}</li>)}</ul>
        <h2 className="card__title">Co na tobě není</h2>
        <ul className="jr-list">{NENI.map((t) => <li key={t}>{t}</li>)}</ul>
      </div>
    </section>
  );
}
